export default {"src":"/_next/static/image/public/images/ic_myprofile_grey_vertical_menu.345101661546a0f3bc0218656511df6e.svg","height":20,"width":20};